import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles, CircularProgress, Tooltip, Chip } from '@material-ui/core';

class FHEItemText extends PureComponent {
    static propTypes = {
        itemTitle: PropTypes.string.isRequired,
        itemContent: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.element]),
        classContent: PropTypes.string,
        className: PropTypes.string,
        onClick: PropTypes.func,
        tooltip: PropTypes.string,
        iconButton: PropTypes.object,
        iconSimple: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
        iconButtonTooltip: PropTypes.string,
        loader: PropTypes.bool,
        chips: PropTypes.array,
        classes: PropTypes.object.isRequired
    };

    static defaultProps = {
        classContent: null,
        className: null,
        onClick: null,
        tooltip: '',
        itemContent: null,
        iconButton: null,
        iconSimple: null,
        iconButtonTooltip: null,
        loader: false,
        chips: []
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: false
        };
    }

    onClickFunc = () => {
        const { onClick } = this.props;
        this.setState({ loading: true });
        onClick().finally(() => {
            this.setState({ loading: false });
        });
    };

    render() {
        const {
            loader,
            itemContent,
            itemTitle,
            classContent,
            className,
            onClick,
            tooltip,
            iconButton,
            iconSimple,
            iconButtonTooltip,
            chips,
            classes
        } = this.props;
        const { loading } = this.state;
        const hasIconAndContent = itemContent !== null && iconSimple !== null;

        if (onClick)
            return (
                <Tooltip placement="top-start" title={tooltip}>
                    <div className={`${className} ${classes.item} ${classes.button}`} role="presentation" onClick={this.onClickFunc}>
                        {loading && <CircularProgress size={20} className={classes.loading} />}
                        <div className={classes.title}>{itemTitle}</div>
                        <div className={`${classes.content} ${classContent}`}>{itemContent}</div>
                    </div>
                </Tooltip>
            );
        else
            return (
                <Tooltip placement="top-start" title={tooltip}>
                    <div className={`${classes.item} ${className}`}>
                        <div className={classes.title}>{itemTitle}</div>
                        {loader ? (
                            <CircularProgress size={20} className={classes.loading} />
                        ) : chips.length ? (
                            <Fragment>
                                {chips.map((data, key) => {
                                    return <Chip key={key} label={data} className={classes.chip} />;
                                })}
                            </Fragment>
                        ) : (
                            <div className={hasIconAndContent ? classes.container : ''}>
                                {iconSimple ? (
                                    <span className={hasIconAndContent ? classes.iconSimpleMargin : classes.iconSimple}>{iconSimple}</span>
                                ) : null}
                                <span className={`${classes.content} ${classes.colorSecondary} ${classContent}`}>{itemContent}</span>
                                {iconButton ? (
                                    <Tooltip title={iconButtonTooltip}>
                                        <span className={`${classes.button} ${classes.iconButton}`}>{iconButton}</span>
                                    </Tooltip>
                                ) : null}
                            </div>
                        )}
                    </div>
                </Tooltip>
            );
    }
}

const styles = theme => ({
    button: {
        cursor: 'pointer'
    },
    iconButton: {
        color: '#858585',
        marginLeft: 10
    },
    iconSimple: {},
    iconSimpleMargin: {
        marginRight: 5,
        display: 'inline-flex'
    },
    item: {
        marginBottom: 10,
        marginTop: 10,
        overflowWrap: 'break-word',
        width: '100%'
    },
    title: {
        fontSize: '0.9em',
        color: '#858585',
        marginBottom: 2,
        overflowWrap: 'break-word'
    },
    loading: {
        display: 'inline',
        float: 'left',
        marginRight: 10
    },
    container: {
        display: 'flex',
        alignItems: 'center'
    },
    chip: {
        color: theme.palette.common.white,
        fontWeight: '500',
        backgroundColor: theme.palette.primary.main,
        marginRight: '5px',
        marginBottom: '5px'
    },
    colorSecondary: {
        color: theme.palette.text.secondary
    },
    content: {}
});

export default withStyles(styles, { withTheme: true })(FHEItemText);



// WEBPACK FOOTER //
// ./data/components/FHEItemText.js